<template>
    <div>
        <span
            v-html="$t('notification.taskAddedTags', {user: getActorName, taskTitle: $_.get(activity, 'payload.taskTitle'), tags: $_.get(activity, 'payload.tags').join(', ') })"></span><span v-if="ruleSource"> (<em>{{ ruleSource }}</em> aracılığıyla)</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskAddedTags",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getActorName() {
            const actorName = this.$_.get(this.activity, "actorUser.name");
            if (actorName) return actorName;
            if (this.$_.get(this.activity, "actor") === "system") return "Sistem";
            return "Bilinmeyen";
        },
        ruleSource() {
            return this.$_.get(this.activity, "payload.ruleSource");
        }
    }
});
</script>
<style scoped lang="scss"></style>
